export default {
  drawerMenuItem: {
    textAlign: 'left',
    paddingLeft: 36,
    fontWeight: 300
  }
}



// WEBPACK FOOTER //
// ./src/styles/components/drawer.js